export enum UserType {
  Distributor = 'DISTRIBUTOR',
  Receiver = 'RECEIVER',
  Admin = 'ADMINISTRATOR',
}
